import { render } from "./info-circle.vue?vue&type=template&id=db5a05f2&ts=true"
import script from "./info-circle.vue?vue&type=script&lang=ts"
export * from "./info-circle.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__